import io from 'socket.io-client';
import store from '@/store';

const socketQuery = (settings) => {
  const {
    token: authToken,
    UUID: id,
    clientType: type,
    clientSubType: subType,
  } = settings;

  const connectionTime = new Date().toISOString();
  const productName = store.getters.product.name;

  return `token=${authToken}
    &username=${id}
    &clientType=${type}
    &clientSubType=${subType}
    &connectionTime=${connectionTime}
    &productName=${productName}`;
};
let gameUuid;
let socketUrl;
let socketOptions;
let socketInstance = null;
let connection = null;

let connectionCheck = null;
let connectionCheckStartTime = null;
let connectionCheckInterval = null;
const connectionCheckDelay = 5000;

export default {
  init(url, platform) {
    connection = this;
    gameUuid = store.state.product.channel;
    socketOptions = {
      query: socketQuery(platform),
      forceNew: true,
      transports: ['websocket'],
    };
    socketUrl = url;
    this.connect();
  },
  connect() {
    if (socketInstance) {
      if (socketInstance.connected) {
        this.reconnect();
      }
      return;
    }

    socketInstance = io(socketUrl, socketOptions);
    this.subscribe();
  },
  disconnect() {
    if (socketInstance !== null) {
      this.unsubscribe();
      socketInstance.disconnect();
      socketInstance = null;
    }
    this.connectionCheck.stop();
  },
  reconnect() {
    this.disconnect();
    setTimeout(() => {
      this.connect();
    }, 500);
  },
  subscribe() {
    socketInstance.on('connect', () => {
      console.log('IO connect');
      socketInstance.emit('subscribe', {
        channel: gameUuid,
        subChannels: {
          language: store.getters.language,
          deliveryPlatform: store.getters.product.deliveryPlatform,
        },
      });
      store.dispatch('socket_connect');
      this.connectionCheck.init();
    });

    socketInstance.on('disconnect', () => {
      console.log('IO disconnect');
      store.dispatch('socket_disconnect');
    });

    socketInstance.on('reconnect', () => {
      console.log('IO reconnect');
    });

    socketInstance.on(gameUuid, (event) => {
      store.dispatch('socket_handleEvent', event);
    });
  },
  unsubscribe() {
    if (socketInstance) {
      socketInstance.emit('unsubscribe', gameUuid);
    }
  },
  connectionCheck: {
    init() {
      connectionCheck = this;
      connectionCheckStartTime = Math.floor(Date.now());

      if (socketInstance) {
        socketInstance.on('tennis', () => {
          connectionCheckStartTime = Math.floor(Date.now());
        });
      }
      connectionCheck.checkAlive();
    },
    stop() {
      if (connectionCheckInterval) {
        clearInterval(connectionCheckInterval);
        connectionCheckInterval = null;
      }
    },
    setAlive() {
      if (socketInstance) {
        socketInstance.emit('table');
      }
    },
    checkAlive() {
      if (connectionCheckInterval) {
        clearInterval(connectionCheckInterval);
        connectionCheckInterval = null;
      }
      connectionCheckInterval = setInterval(() => {
        if (Math.floor(Date.now()) - connectionCheckStartTime > connectionCheckDelay + 1000) {
          connection.reconnect();
        } else {
          connectionCheck.setAlive();
        }
      }, connectionCheckDelay);
    },
  },
};
